const API_URL = process.env.REACT_APP_BACKEND_URL;

// Track event to our own backend analytics
const trackToBackend = async (eventType, path, metadata = {}) => {
  try {
    await fetch(`${API_URL}/api/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event_type: eventType,
        path: path || window.location.pathname,
        metadata
      })
    });
  } catch (e) {
    // Silent fail — don't block UX for analytics
  }
};

// Google Ads conversion tracking helpers
export const trackBookNowClick = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: 'AW-17527167409/book_now_click',
      event_category: 'engagement',
      event_label: 'Book Now Button Click'
    });
    window.gtag('event', 'book_now_click', {
      event_category: 'CTA',
      event_label: 'Book Now'
    });
  }
  trackToBackend('book_now_click', window.location.pathname);
};

export const trackContactFormSubmit = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: 'AW-17527167409/contact_form_submit',
      event_category: 'lead',
      event_label: 'Contact Form Submission'
    });
    window.gtag('event', 'generate_lead', {
      event_category: 'Lead',
      event_label: 'Contact Form'
    });
  }
  trackToBackend('contact_submit', '/contact');
};

export const trackPhoneClick = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: 'AW-17527167409/phone_click',
      event_category: 'engagement',
      event_label: 'Phone Number Click'
    });
    window.gtag('event', 'click_to_call', {
      event_category: 'CTA',
      event_label: 'Phone Call'
    });
  }
  trackToBackend('phone_click', window.location.pathname);
};

export const trackPageView = (pageName) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      page_title: pageName,
      page_location: window.location.href
    });
  }
  trackToBackend('page_view', window.location.pathname, { page_title: pageName });
};
